export class NumberHelper {
    public static anyToInteger(value: any): number {
        const result = parseInt(value);
        if (isNaN(result)) {
            return null;
        }
        return result;
    }
}
